module.exports = __webpack_public_path__ + "img/star-and-crescent.74d45a23.svg";